<template>
  <table class="table b-table  table-hover table-bordered no-wrap">
    <thead>
      <tr>
        <td>Início</td>
        <td>Fim</td>
        <td>Valor Investido</td>
        <td>Valor</td>
        <td>Comissão</td>
        <td>Valor a receber</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in list" :key="item.id">
        <td>{{ formatDate(item.start) }}</td>
        <td>{{ item.end ? formatDate(item.end) : '' }}</td>
        <td>
          {{ (item.value ? item.value : 0) | currency }}
        </td>
        <td>
          {{ (item.valueToReceive ? item.valueToReceive : 0) | currency }}
        </td>
        <td>{{ item.comission ? item.comission : 0 }} %</td>
        <td>{{ (item.traderValue ? item.traderValue : 0) | currency }}</td>
      </tr>
      <tr>
        <td colspan="5"></td>
        <td>
          <strong>Total: {{ getTotalTraderValue() | currency }}</strong>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { Api } from '../../vue/api';
import moment from 'moment-timezone';

const API = new Api();

export default {
  name: 'sales-comissions-index-report-invesments-table',
  data: function() {
    return {};
  },
  computed: {},
  methods: {
    formatDate(date) {
      return moment(date).format('L');
    },
    getTotalTraderValue() {
      return _.sumBy(this.list, b => b.traderValue);
    },
  },
  props: ['list'],
};
</script>
